//文字コードはutf-8

import { initHamburgerMenu } from './modules/hamburger.js';
import { initSlider } from './modules/slider.js';
import { initTopParallax } from './modules/topParallax.js';
import { initTopKvVideo } from './modules/topKvVideo.js';
import { initModal } from './modules/modal.js';
import { initHeaderColorSwitch } from './modules/headerColorSwitch.js';
import { initHeaderLogo } from './modules/headerLogo.js';
import { initTopFixedLinks } from './modules/topFixedLinks.js';
import coursePickup from './modules/coursePickup.js';
import { initSmoothScroll } from './modules/smoothScroll.js';
import { initKvZoomAnimation } from './modules/kvZoomAnimation.js';
import { initPageLoader } from './modules/pageLoader.js';

initHamburgerMenu();
initSlider();
initTopParallax();
initTopKvVideo();
initModal();
initHeaderColorSwitch();
initHeaderLogo();
initTopFixedLinks();
coursePickup();
initSmoothScroll();
initKvZoomAnimation();
initPageLoader();
